export interface RecordResult {
  id: string;
  result?: string | null;
  resultNumber?: number | null;
  date?: string | null;
}

export interface RecordItem {
  id: string;
  name: string;
  category?: string | null;
  unit?: string | null;
  image?: {uri?: string | null} | null;
  lastResult?: RecordResult | null;
}

// `result` e String livre ("12 reps", "1:30") e `resultNumber` e o valor
// numerico. Preferir a string preserva o que o aluno digitou; o numero e
// fallback e so entao a unidade do exercicio entra.
export const marcaDoRecorde = (item: RecordItem): string => {
  const bruto = item.lastResult?.result?.trim();
  if (bruto) return bruto;

  const numero = item.lastResult?.resultNumber;
  if (numero === null || numero === undefined) return '';

  const unidade = item.unit?.trim();

  return unidade ? `${numero} ${unidade}` : `${numero}`;
};

export const temMarca = (item: RecordItem): boolean => marcaDoRecorde(item).length > 0;

// `date` vem como String do backend, em formato nao garantido; se nao der para
// interpretar, melhor omitir a data do que mostrar "Invalid Date".
export const dataDaMarca = (item: RecordItem): string => {
  const bruto = item.lastResult?.date?.trim();
  if (!bruto) return '';

  const data = new Date(bruto.replace(' ', 'T'));
  if (Number.isNaN(data.getTime())) return '';

  return data.toLocaleDateString('pt-BR', {day: '2-digit', month: '2-digit', year: 'numeric'});
};

// A busca vai para o backend a cada tecla se nao houver espera; 400ms e o
// suficiente para digitar sem disparar uma query por caractere.
export const DEBOUNCE_BUSCA = 400;

export const buscaValida = (termo: string): boolean => {
  const limpo = termo.trim();

  // Um caractere so devolveria quase o catalogo inteiro sem ajudar ninguem.
  return limpo.length === 0 || limpo.length >= 2;
};
